module.exports = __webpack_public_path__ + "static/media/img.71610aca.jpg";